import { Copy, EditIcon, Trash } from "lucide-react";
import { StationFormData } from "../schemas/station";

interface StationsTableProps {
  stations: {
    id: number;
    name: string;
    connectorId: string;
    paymentId: string;
    currency: string;
    pricePerKWh: string;
  }[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onCopy: (station: StationFormData) => void;
}

export const StationsTable = ({
  stations,
  onEdit,
  onDelete,
  onCopy,
}: StationsTableProps) => (
  <div className="bg-white rounded-lg shadow overflow-hidden">
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center gap-2 cursor-pointer hover:text-gray-700">
                Name
              </div>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Connector Id
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Payment Id
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Currency
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Price per kWh
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {stations.length > 0 &&
            stations.map((station) => (
              <tr key={station.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="font-medium text-gray-900">
                    {station.name}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                  {station.connectorId}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-gray-500">
                  {station.paymentId}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {station.currency}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {station.pricePerKWh}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <div className="flex justify-end items-center gap-4">
                    <EditIcon
                      size={"24px"}
                      className="cursor-pointer"
                      onClick={() => onEdit(station.id)}
                    />
                    <Trash
                      size={"24px"}
                      onClick={() => onDelete(station.id)}
                      className="cursor-pointer text-red-500"
                    />
                    <Copy
                      size={"24px"}
                      onClick={() => onCopy(station as StationFormData)}
                      className="cursor-pointer text-gray-500"
                    />
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  </div>
);
